/* GLO listicle — scroll reveals, sticky CTA, UGC rail, countdown.
   Re-binds on Shopify's section events so it keeps working in the editor. */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- scroll reveal ---------- */
  function initReveals(root) {
    var rises = (root || document).querySelectorAll(".glo-rise:not([data-glo-seen])");
    if (!rises.length) return;
    function show(el) { el.setAttribute("data-glo-seen", "1"); el.classList.add("glo-is-in"); }

    if (reduce || !("IntersectionObserver" in window)) {
      rises.forEach(show);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.05 });
    rises.forEach(function (el) { io.observe(el); });
    setTimeout(function () { rises.forEach(show); }, 2500);   // never leave content invisible
  }

  /* ---------- sticky CTA ----------
     Keep the existing top animation. For bottom placement, hide the bar
     below the viewport and slide it upward using the existing transition. */
  function initSticky() {
    var sticky = document.getElementById("glo-sticky");
    if (!sticky || sticky.dataset.gloBound) return;
    sticky.dataset.gloBound = "1";

    if (!document.getElementById("glo-sticky-position-styles")) {
      var style = document.createElement("style");
      style.id = "glo-sticky-position-styles";
      style.textContent =
        '#glo-sticky[data-glo-bottom]:not(.glo-is-on) {' +
          'transform: translateY(calc(100% + 20px)) !important;' +
        '}' +
        '#glo-sticky[data-glo-bottom].glo-is-on {' +
          'transform: translateY(0) !important;' +
        '}';
      document.head.appendChild(style);
    }

    var hero = document.getElementById("glo-hero");

    function syncPosition() {
      var styles = window.getComputedStyle(sticky);
      var atBottom = parseFloat(styles.bottom) === 0;

      if (atBottom) {
        sticky.setAttribute("data-glo-bottom", "");
      } else {
        sticky.removeAttribute("data-glo-bottom");
      }
    }

    function sync() {
      var pastHero = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 500;
      sticky.classList.toggle("glo-is-on", pastHero);

      if (sticky.hasAttribute("data-glo-hide-header")) {
        document.documentElement.classList.toggle("glo-hide-theme-header", pastHero);
      }
    }

    syncPosition();
    sync();

    window.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", function () {
      syncPosition();
      sync();
    });
  }

  /* ---------- #glo-buy ----------
     The buybox was replaced by the theme's own featured-product section, so
     that anchor has no element. Route those CTAs to the real product
     section instead of leaving them dead. */
  function initBuyLinks() {
    if (document.body.dataset.gloBuyBound) return;
    document.body.dataset.gloBuyBound = "1";

    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var a = e.target.closest('a[href="#glo-buy"]');
      if (!a) return;
      var target = document.getElementById("glo-buy") ||
                   document.querySelector(".featured-product") ||
                   document.querySelector(".main-product");
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  /* ---------- countdown ----------
     Rolls over on a fixed cycle so the offer never reads expired. */
  function initTimer(root) {
    (root || document).querySelectorAll("[data-glo-timer]").forEach(function (el) {
      if (el.dataset.gloBound) return;
      el.dataset.gloBound = "1";

      var hours = parseInt(el.dataset.gloTimerHours, 10) || 24;
      var cycle = hours * 3600000;
      var out = {
        d: el.querySelector('[data-glo-t="d"]'),
        h: el.querySelector('[data-glo-t="h"]'),
        m: el.querySelector('[data-glo-t="m"]'),
        s: el.querySelector('[data-glo-t="s"]')
      };
      var pad = function (n) { return n < 10 ? "0" + n : String(n); };

      function tick() {
        var left = cycle - (Date.now() % cycle);
        var secs = Math.floor(left / 1000);
        if (out.d) out.d.textContent = pad(Math.floor(secs / 86400));
        if (out.h) out.h.textContent = pad(Math.floor(secs / 3600) % 24);
        if (out.m) out.m.textContent = pad(Math.floor(secs / 60) % 60);
        if (out.s) out.s.textContent = pad(secs % 60);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ---------- rails: arrows + dots, video play only while on screen ---------- */
  function initRails(root) {
    (root || document).querySelectorAll("[data-glo-rail]").forEach(function (wrap) {
      if (wrap.dataset.gloBound) return;
      wrap.dataset.gloBound = "1";

      var rail = wrap.querySelector(".glo-rail");
      if (!rail) return;

      var cards = function () { return Array.prototype.slice.call(rail.children); };
      var step = function () {
        var card = rail.firstElementChild;
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : 320;
      };

      wrap.querySelectorAll("[data-glo-rail-btn]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          rail.scrollBy({ left: btn.dataset.gloRailBtn === "next" ? step() : -step(), behavior: "smooth" });
        });
      });

      /* ---- dot pagination: one dot per card, active dot follows scroll ---- */
      var dots = wrap.querySelectorAll("[data-glo-rail-dot]");
      if (dots.length) {
        dots.forEach(function (dot, i) {
          dot.addEventListener("click", function () {
            var card = cards()[i];
            if (card) rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft, behavior: "smooth" });
          });
        });

        var syncDots = function () {
          var list = cards();
          var center = rail.scrollLeft + rail.clientWidth / 2;
          var active = 0;
          var best = Infinity;
          list.forEach(function (card, i) {
            var mid = card.offsetLeft - rail.offsetLeft + card.offsetWidth / 2;
            var dist = Math.abs(mid - center);
            if (dist < best) { best = dist; active = i; }
          });
          dots.forEach(function (dot, i) { dot.classList.toggle("is-active", i === active); });
        };

        var raf = null;
        rail.addEventListener("scroll", function () {
          if (raf) return;
          raf = requestAnimationFrame(function () { syncDots(); raf = null; });
        }, { passive: true });
        syncDots();
      }

      if (reduce || !("IntersectionObserver" in window)) return;

      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () { /* autoplay blocked — poster stays */ });
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.4 });

      rail.querySelectorAll("video").forEach(function (v) {
        v.muted = true;
        v.setAttribute("playsinline", "");
        vio.observe(v);
      });
    });
  }

  /* ---------- scroll-to-section links, portable across themes ----------
     Shopify's auto section id is template--<numeric id>__<key>, and that
     numeric id differs per theme even for a byte-identical template file
     (e.g. draft vs live). Matching on the [id*="__<key>"] suffix instead
     of a hardcoded id means a link like data-glo-scroll-target="glo_foo"
     keeps working wherever this file gets pushed. */
  function initScrollLinks() {
    if (document.body.dataset.gloScrollBound) return;
    document.body.dataset.gloScrollBound = "1";

    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var a = e.target.closest("[data-glo-scroll-target]");
      if (!a) return;
      var key = a.dataset.gloScrollTarget;
      var target = document.querySelector('[id*="__' + key + '"]');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  function boot(root) {
    initReveals(root);
    initSticky();
    initRails(root);
    initBuyLinks();
    initScrollLinks();
    initTimer(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  document.addEventListener("shopify:section:select", function (e) { boot(e.target); });
})();